import { render, staticRenderFns } from "./EmailDuplicates.vue?vue&type=template&id=a974c0ac&scoped=true"
import script from "./EmailDuplicates.vue?vue&type=script&lang=js"
export * from "./EmailDuplicates.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a974c0ac",
  null
  
)

export default component.exports
import QCard from 'quasar/src/components/card/QCard.js';
import QSpace from 'quasar/src/components/space/QSpace.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import QSlideTransition from 'quasar/src/components/slide-transition/QSlideTransition.js';import ClosePopup from 'quasar/src/directives/ClosePopup.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QCard,QSpace,QBtn,QSeparator,QSlideTransition});qInstall(component, 'directives', {ClosePopup});
